'use client';

interface CategoryFilterProps {
  currentLang?: 'sl' | 'en';
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({ 
  currentLang = 'sl',
  selectedCategory,
  onCategoryChange
}: CategoryFilterProps) {
  const categories = [
    { id: 'all', label: currentLang === 'sl' ? 'Vse' : 'All' },
    { id: 'tips', label: currentLang === 'sl' ? 'Nasveti' : 'Tips' },
    { id: 'stories', label: currentLang === 'sl' ? 'Zgodbe' : 'Stories' },
    { id: 'health', label: currentLang === 'sl' ? 'Zdravje' : 'Health' },
    { id: 'recipes', label: currentLang === 'sl' ? 'Recepti' : 'Recipes' },
    { id: 'sustainability', label: currentLang === 'sl' ? 'Trajnostnost' : 'Sustainability' },
  ];

  return (
    <div className="mb-12 flex flex-wrap gap-3 justify-center">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
            selectedCategory === category.id
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'bg-muted text-muted-foreground hover:bg-primary/10'
          }`}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
}